// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__37Cuz","alertIcon":"ConfirmModal_alertIcon__1JOnx"};